import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import InstalledAtInfo from '../components/info';
import {
  fetchInstalledAtInfo,
  saveInstalledAtInfoRequest,
  verifyInstalledAtInfoRequest,
  installedAtInfoSuccess,
} from './installed-at-info-actions';

const mapStateToProps = state => ({
  data: state.installedAt.info.data,
  isLoading: state.installedAt.info.isLoading,
  error: state.installedAt.info.error,
  isSaving: state.installedAt.info.isSaving,
  saveSuccess: state.installedAt.info.saveSuccess,
  lock: state.installedAt.info.lock,
  lockingErrorType: state.installedAt.info.lockingErrorType,
  lockingErrors: state.installedAt.info.lockingErrors,
});

const mapDispatchToProps = {
  fetchInfo: fetchInstalledAtInfo,
  saveInstalledAtInfoRequest,
  verifyInstalledAtInfoRequest,
  installedAtInfoSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InstalledAtInfo));
